<template>
  <div>
    <Restricted ref="restrictedRef" />
    <Risk ref="riskRef" />
    <Limits ref="limitsRef" />
    <PendingAccountNotice ref="pendingRef" />
  </div>
</template>

<script>
import Restricted from './Restricted.vue'
import Risk from './Risk.vue'
import Limits from './Limits.vue'
import PendingAccountNotice from '@/views/_components/BillingInfo/PendingAccountNotice.vue'

export default {
  name: 'Alerts',
  components: {
    Restricted,
    Risk,
    Limits,
    PendingAccountNotice
  },
  watch: {
    '$route.fullPath'() {
      this.$refs.pendingRef.close()
    }
  },
  methods: {
    openPendingReview() {
      this.$refs.restrictedRef.close()
      this.$refs.pendingRef.open({ type: 'account' })
    },
    openRestricted() {
      // 已完成资料且无待验证步骤时，展示审核进度，不再要求用户验证。
      if (this.$store.getters['client/isPendingReview']) {
        this.openPendingReview()
        return
      }
      if (this.$refs.restrictedRef) {
        this.$refs.restrictedRef.open()
      }
    },
    openRisk() {
      if (this.$refs.riskRef) {
        this.$refs.riskRef.open()
      }
    },
    openLimits() {
      if (this.$refs.limitsRef) {
        this.$refs.limitsRef.open()
      }
    }
  }
}
</script>

<style scoped></style>
